import Link from 'redux-first-router-link';

export default Link;